import WingsAboveAmericasNationalParks from "./images/AirtourMaps/WingsAboveAmericasNationalParks.jpg"
import WingsOverTheWest from "./images/AirtourMaps/WingsOverTheWest.jpg"
import WesternExpress from "./images/AirtourMaps/WesternExpress.jpg"
import CowboysAndCanyons from "./images/AirtourMaps/CowboysAndCanyons.jpg"

export default [
  {
    title: "ATI Premium",
    tours: [
      {
        title: "Wings Above America's National Parks",
        hero: WingsAboveAmericasNationalParks,
        header: {
          days: 15,
          nights: 14,
          start: "San Francisco",
          end: "San Francisco"
        },
        highlights: [
          "Welcome reception",
          "Private Aircraft on all flight sectors",
          "Tour 17-Mile Drive and Monterey’s Cannery Row",
          "San Francisco Bay Cruise",
          "Comprehensive city tour of San Francisco",
          "Antelope Canyon tour",
          "Guided tour of Yosemite National Park",
          "Guided tour of Grand Canyon National Park",
          "Grand Canyon Picnic Lunch",
          "Ride the Grand Canyon Railway to Williams on Historic Route 66",
          "Comprehensive city tour of Los Angeles",
          "Free time to explore",
          "1 Lunch, 3 Dinners"
        ],
        optionals: [
          "Dinner in the Golden City: San Francisco",
          "Monument Valley Jeep tour",
          "Las Vegas Night Tour"
        ],
        body:
          "See America's National Parks from the air and ground including Yosemite, the Grand Canyon, Bryce and Zion. This is the ultimate way to sightsee and a truly one-of-a-kind experience."
      },
      {
        title: "Wings Over the West",
        hero: WingsOverTheWest,
        header: {
          days: 15,
          nights: 14,
          start: "Las Vegas",
          end: "Las Vegas"
        },
        highlights: [
          "Daily Breakfast Included",
          "Welcome reception",
          "Private Aircraft on all flight sectors",
          "Comprehensive city tour of Los Angeles",
          "Guided tour of Grand Canyon National Park",
          "Guided tour of Yosemite National Park",
          "San Francisco Bay Cruise",
          "Comprehensive city tour of San Francisco",
          "Napa Valley and Sonoma with wine tasting and vineyard tour",
          "Tour 17-Mile Drive and Monterey’s Cannery Row",
          "Free time to explore",
          "Antelope Canyon Tour",
          "Visit Lake Powell, Zion and Monument Valley",
          "Grand Canyon Picnic Lunch"
        ],
        optionals: [
          "Dinner in the Golden City: San Francisco",
          "Los Angeles by Night Tour and Dinner",
          "Monument Valley Jeep Tour",
          "Las Vegas Night Tour"
        ],
        body:
          "This unique air/ground tour takes you from Los Angeles to the West Coast's must-see destinations of Las Vegas, the Grand Canyon, Yosemite National Park, the Wine Country, San Francisco and Monterey. Come discover the best of the American West."
      },
      {
        title: "Western Express",
        hero: WesternExpress,
        header: {
          days: 10,
          nights: 9,
          start: "Las Vegas",
          end: "Las Vegas"
        },
        highlights: [
          "Daily Breakfast Included",
          "Welcome reception",
          "Private Aircraft on all flight sectors",
          "Tour 17-Mile Drive and Monterey’s Cannery Row",
          "San Francisco Bay Cruise",
          "Comprehensive city tour of San Francisco",
          "Guided tour of Yosemite National Park",
          "Comprehensive city tour of Los Angeles",
          "Free time to explore",
          "Napa Valley and Sonoma with wine tasting and vineyard tour"
        ],
        optionals: [
          "Dinner in the Golden City: San Francisco",
          "Guided tour to Grand Canyon National Park"
        ],
        body: " "
      },
      {
        title: "Cowboys and Canyons",
        hero: CowboysAndCanyons,
        header: {
          days: 7,
          nights: 6,
          start: "Las Vegas",
          end: "Las Vegas"
        },
        highlights: [
          "Guided tour of Grand Canyon National Park",
          "Grand Canyon Picnic Lunch",
          "Ride the Grand Canyon Railway to Williams on Historic Route 66",
          "Napa Valley and Sonoma with wine tasting and vineyard tour",
          "Antelope Canyon Tour",
          "Visit Lake Powell, Monument Valley, Bryce Canyon and Zion National Parks",
          "Free time to explore",
          "Daily Breakfast Included"
        ],
        optionals: ["Monument Valley Jeep tour", "Las Vegas Night Tour"],
        body: " "
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/airTours.js